<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="22">
          <a-col :md="6" :sm="22">
            <a-form-item label="关键字">
              <a-input v-model.trim="queryParam.searchStr" placeholder="订单号\师傅名称\师傅电话"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 5px">
              <a-select v-model.trim="queryParam.state" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in auditStatus" :title="type.dictLabel" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="补价类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 5px">
              <a-select v-model.trim="queryParam.types" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in reasonPriceType" :title="type.dictLabel" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="申请开始日期" style="margin-left: 5px">
              <a-date-picker
                v-model="queryParam.time1"
                style="width:100%"
                show-time
                :disabled-date="disabledStartDate"
                format="YYYY-MM-DD"
                @change="onChange1"
                @ok="onOk1"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="申请结束日期" >
              <a-date-picker
                v-model="queryParam.time2"
                style="width:100%"
                show-time
                :disabled-date="disabledEndDate"
                format="YYYY-MM-DD"
                @change="onChange2"
                @ok="onOk2"
              />
            </a-form-item>
          </a-col>

          <a-col :span="22" style="text-align: right">
            <a-button type="primary" htmlType="submit" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <div class="table-operator">

    </div>
    <s-table
      size="default"
      ref="table"
      rowKey="id"

      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a v-if="record.state==0" @click="handleEdit(record.id)">审核</a>
        <a-divider type="vertical" />
        <a @click="handleInfo(record)">查看</a>
      </span>
    </s-table>
    <increaseAuditModel ref="modal" @ok="handleOk"/>
    <increaseAuditInfo ref="modalInfo" @ok="handleOk"/>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import pick from 'lodash.pick'
import moment from 'moment'
import { queryOrderList } from '@/api/order/increaseAuditList'
import increaseAuditModel from './modules/increseAuditModel.vue'
import increaseAuditInfo from './modules/increaseAuditInfo.vue'
import {
  getfinddictAll
} from '@/api/order/orderList'

export default {
  name: 'TableList',
  components: {
    STable,
    increaseAuditModel,
    increaseAuditInfo
  },
  data () {
    return {
      data: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 字典为安装类型
      auditStatus: [],
      reasonPriceType: [],
      // 表头
      columns: [
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '订单号',
          align: 'center',
          dataIndex: 'orderNo'
        },
        {
          title: '补价类型',
          align: 'center',
          dataIndex: 'types'

        },

        {
          title: '补价金额',
          align: 'center',
          dataIndex: 'price'

        },
        {
          title: '师傅名称',
          align: 'center',
          dataIndex: 'workName'

        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'stateName'

        },
        {
          title: '订单负责人',
          align: 'center',
          dataIndex: 'orderPrincipal'

        },
        {
          title: '企业简称',
          align: 'center',
          dataIndex: 'enterpriseSysName'

        },
        {
          title: '申请日期',
          align: 'center',
          dataIndex: 'createTime'

        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return queryOrderList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  filters: {
  },
  async created () {
    const dictTypes = ['audit_status', 'reason_price_type']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.auditStatus = res.audit_status
      this.reasonPriceType = res.reason_price_type
      console.log(this.installTypes)
    })
  },
  methods: {

    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleAdd () {
      this.$refs.modal.add()
    },
    handleEdit (id) {
      this.$refs.modal.edit(id)
    },
    handleInfo (record) {
      this.$refs.modalInfo.edit(record)
    },
    handleOk () {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },

    onChange1 (value, dateString) {
      this.queryParam.startTime = dateString
    },
    onChange2 (date, dateString) {
      this.queryParam.endTime = dateString
    }

  },
  watch: {

  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px;}
</style>
